export default __webpack_public_path__ + "static/media/trans-wedding.9ce4531f.png";